var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",style:(_vm.styleItem)},[_c('div',{staticClass:"item-inner",class:{
            'item-centered' : _vm.isCenterd,
            'item-centered-sides': _vm.indexDiff === 1,
            'item-centered-sides-2': _vm.indexDiff === 2,
            'item-centered-sides-3': _vm.indexDiff === 3,
        },style:(_vm.itemInnerStyle),on:{"click":function () {
            _vm.indexDiff - 1 < (_vm.showCount / 2) && _vm.onItemClick(_vm.item)
        }}},[_c('div',{staticClass:"mask-carousel"}),_c('div',{staticClass:"item-label"},[_vm._v("\n            "+_vm._s(_vm.item.text)+"\n        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }